module.exports = __webpack_public_path__ + "img/solution_txt@2x.de60b11d.png";